import React from 'react'
import styled from 'styled-components'
import { Box } from 'uikit'
import Intro from './components/Intro'
import Quality from './components/Quality'
import Scaliing from './components/Scaliing'
import Launchpad from './components/Launchpad'
import Nft from './components/Nft'
import Earn from './components/Earn'
import Token from './components/Token'
// import NeedToKnow from './components/NeedToKnow'

const Container = styled(Box)`
  background: linear-gradient(180deg, #101010 0%, #101010 100%);
`

const ModelBg = styled(Box)`
  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url('/images/home/launchpad-nft-earn-bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`

const Home: React.FC = () => {
  return (
    <Container pb={['50px', null, null, null, '80px']}>
      <Intro />
      <Quality />
      <Scaliing />
      <ModelBg px={['30px', null, '54px']}>
        <Launchpad />
        <Nft />
        <Earn />
      </ModelBg>
      <Token />
      {/* <NeedToKnow /> */}
    </Container>
  )
}

export default Home
